import LoadingButton from '@mui/lab/LoadingButton';
import {Container, InputAdornment, TextField} from '@mui/material';
import Grid from '@mui/material/Grid';

import {useFormik} from 'formik';
import {useEffect, useState} from 'react';
import useHandleErrors from '../../../hooks/useHandleErrors';
import server from '../../../global/server';
import {useSnackbar} from 'notistack';
import {useFetch} from '../../../hooks/useFetch';
import SelectProduct from '../../../components/SelectProduct';

export default () => {
    const [errs, setErrs] = useState();
    useHandleErrors(errs);

    const {data, error, mutate, isLoading} = useFetch('/settings');
    useHandleErrors(error);

    const {enqueueSnackbar} = useSnackbar();

    const {values, errors, handleChange, handleSubmit, handleBlur, isSubmitting, setValues, setFieldValue} =
        useFormik({
            initialValues: {
                // empiria_fee: '',
                duty_product: '',
                front_version: '',
            },
            onSubmit: async (values, {setSubmitting}) => {
                try {
                    setSubmitting(true)
                    console.log(values)
                    const response = await server.put('/settings', values);
                    enqueueSnackbar('Configuração alterada');
                    mutate()
                    setSubmitting(false);
                } catch (error) {
                    setSubmitting(false);
                    setErrs(error);
                }
            },
        });

    useEffect(() => {
        if (data) {
            console.log(data)
            setValues(data, true);
        }
    }, [data]);

    return (
        <>
            <Grid container spacing={2} alignItems="center">
                {/* <Grid item xs={4}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        required
                        label="Comissão Empiria %"
                        type="number"
                        name="empiria_fee"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.empiria_fee}
                        error={errors.empiria_fee}
                        helperText={errors.empiria_fee}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                    />
                </Grid>

                <Grid item xs={4}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        required
                        label="Custom por chamada"
                        type="text"
                        name="call_cost_fee"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.call_cost_fee}
                        error={errors.call_cost_fee}
                        helperText={errors.call_cost_fee}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                        }}
                    />
                </Grid> */}
                <Grid item xs={4}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        required
                        label="Versão do front"
                        type="text"
                        name="front_version"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.front_version}
                        error={errors.front_version}
                        helperText={errors.front_version}                        
                    />
                </Grid>
                <Grid item xs={4}>
                    <SelectProduct value={values.duty_product} name="duty_product" onChange={setFieldValue} label="Produto para o Plantão" />
                </Grid>

                <Grid container item direction="row" justifyContent="flex-end" alignItems="center">
                    <Grid>
                        <LoadingButton
                            onClick={handleSubmit}
                            loading={isSubmitting}
                            variant="contained">
                            Salvar dados
                        </LoadingButton>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};
